import { z } from "zod";
import {
  ASSIGN_TO,
  START_DATE,
  END_DATE,
  NAME,
  NOTES,
  PRIORITY,
  ROLE,
  SCHOOL,
  TASK_ATTACHMENT,
  TASK_STATUS,
  TASKS,
  ASSIGNEES,
  TASK_ATTACHMENT_NAME,
} from "../consts";

// Task object schema
const baseTaskSchema = z.object({
  [START_DATE]: z.string().min(1, "Start Date is required"),
  [END_DATE]: z.string().min(1, "End Date is required"),
  [TASK_STATUS]: z.string().min(1, "Task Status is required"),
  [TASK_ATTACHMENT]: z.union([z.string(), z.instanceof(File)]).optional(),
  [TASK_ATTACHMENT_NAME]: z.string().optional(),
  [ASSIGNEES]: z
  .array(
    z.object({
      [SCHOOL]: z.string().min(1, "School is required"),
      [ROLE]: z.string().min(1, "Role is required"),
      [ASSIGN_TO]: z.string().min(1, "Assign To is required"),
    })
  )
  .min(1, "At least one assignee is required"),
});

// New Task schema: requires name, priority, notes
const newTaskSchema = baseTaskSchema.extend({
  [NAME]: z.string().min(3, "Valid Task Name is required"),
  [PRIORITY]: z.string().min(1, "Priority is required"),
  [NOTES]: z.string().min(10, "Valid Task Notes are required"),
});

// Predefined Task schema: name, priority, notes come from table, optional here
const predefinedTaskSchema = baseTaskSchema.extend({
  [NAME]: z.string().optional(),
  [PRIORITY]: z.string().optional(),
  [NOTES]: z.string().optional(),
});

// Main form schema
export const schema = z.object({
  selectedCategory: z.string().optional(),
  [TASKS]: z.array(z.union([newTaskSchema, predefinedTaskSchema])),
});


export type formValues = z.infer<typeof schema>;